import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, switchMap } from 'rxjs';
import { Observable, from, of } from 'rxjs';
import { catchError, map, mapTo } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '..';
import * as AuthenticationActions from '../../screens/login/state/login.actions';
import * as fromAuthentication from '../../screens/login/state/login.selectors';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private _authService: AuthenticationService,
    private _router: Router,
    private store: Store<fromAuthentication.State>
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.isAllowedAccess(next, state);
  }

  // canLoad(): Observable<boolean> {
  //   return this.isAllowedAccess();
  // }

  private isAllowedAccess(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return combineLatest([
      this._authService.validateSession(),
      this.store.select(fromAuthentication.getUser),
    ]).pipe(
      switchMap(([res, session]) => {
        if (res != true) {
          if (!environment.API_URL.includes('m.lke')) {
            return this._authService.SingleSignOn().pipe(
              map((session: any) => {
                if (session.guid) {
                  this.store.dispatch(
                    new AuthenticationActions.LoginSuccess(session)
                  );
                  return true;
                } else {
                  this.store.dispatch(
                    new AuthenticationActions.LoginRedirect()
                  );
                  return false;
                }
              }),
              catchError((err: Error) => {
                this._router.navigate(['/login']);
                return of(false);
              })
            );
          } else {
            this._router.navigate(['/login']);
            return of(false);
          }
        } else {
          let result: boolean = true;
          if (Object.keys(next.data).includes('role')) {
            result = next.data['role'].some(
              (role) =>
                session.userRolesForApplication
                  .split('|')
                  .findIndex((r) => r === role) > -1
            );
          }
          return of(result);
        }
      })
    );
  }
}
